import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ClientDetailContactModel from "../../models/client-detail-contact";

export default class ClientDetailContactRepository extends BaseRepository {
  static modelClass = ClientDetailContactModel;
  modelName = "client-detail-contact";

  async query(caseId, params = {}) {
    return await super.query({
      urlPath: `case/${caseId}/contacts/?${qs.stringify(params)}`,
    });
  }
}
